<template>
	<PopUpMessageNext
		v-model:visible="vData"
		tabindex="-1"
		role="dialog"
		aria-modal="true"
		aria-label="Výběr pobočky"
		custom-overflow
	>
		<HypermarketSelectionBanner
			show-links
			class="mt-2"
			@update:hm="vData = false"
		/>
	</PopUpMessageNext>
</template>

<script setup lang="ts">
	interface Props {
		visible: boolean
		changeWithRedirect?: boolean
	}

	interface Emits {
		(e: 'update:visible', payload: boolean): void
	}

	const props = defineProps<Props>();
	const emit = defineEmits<Emits>();

	const vData = useVModel(props, 'visible', emit);
</script>
